import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.autogrow = this.autogrow.bind(this)

    this.element.style.overflow = "hidden"

    this.element.addEventListener("input", this.autogrow)
  }

  disconnect() {
    this.element.removeEventListener("input", this.autogrow)
  }

  autogrow() {
    this.element.style.height = "auto" // Force re-print before calculating the scrollHeight value.
    this.element.style.height = `${this.element.scrollHeight}px`
  }
}
